import Section from "../components/Section";
import { Button, Toastr, Dropdown } from "../components";
import { useState } from "react";
import image from "../assets/logo.png";
import { CodepenLogo } from "@phosphor-icons/react";

type ToastrState = {
  [key in
    | "primary"
    | "image"
    | "avatar"
    | "gray"
    | "error"
    | "warning"
    | "success"
    | "progress"
    | "none"]: boolean;
};

export default function ToastrSection() {
  const [show, setShow] = useState<ToastrState>({
    primary: false,
    error: false,
    warning: false,
    progress: false,
    gray: false,
    none: false,
    success: false,
    avatar: false,
    image: false,
  });
  const [showActions, setShowActions] = useState(false);
  const [showAvatar, setShowAvatar] = useState(false);
  const [showcustom, setShowCustom] = useState(false);
  const [iconColor, setIconColor] = useState<
    "gray" | "error" | "warning" | "success" | "brand"
  >("gray");
  const [statusIcon, setStatusIcon] = useState<
    "online" | "verified" | "company" | "offline" | undefined
  >(undefined);

  const [iconSize, setIconSize] = useState<"sm" | "md" | "lg" | "xl">("sm");
  const text =
    "Check out the all new dashboard view. Pages and exports now load faster.";
  const heading = "We’ve just released a new update!";

  const handleToggle = (key: keyof ToastrState) => {
    setShow((prevState) => ({ ...prevState, [key]: !prevState[key] }));
  };

  const handleDropdownChange = (value: any) => {
    setIconColor(value.value);
  };
  const handleStatusIconChange = (value: any) => {
    setStatusIcon(value.value);
  };
  const handleIconSizeChange = (value: any) => {
    setIconSize(value.value);
  };

  return (
    <>
      <Section title={"#Toastr"}>
        <Dropdown
          options={[
            { label: "Gray", value: "gray" },
            { label: "Success", value: "success" },
            { label: "Error", value: "error" },
            { label: "Warning", value: "warning" },
            { label: "Brand", value: "brand" },
          ]}
          label="Icon Color"
          onChange={handleDropdownChange}
          value={{ label: iconColor, value: iconColor }}
        />
        <Dropdown
          options={[
            { label: "Online", value: "online" },
            { label: "Verified", value: "verified" },
            { label: "Company", value: "company" },
            { label: "None", value: "" },
          ]}
          label="Avatar Status Icon"
          onChange={handleStatusIconChange}
          value={{ label: statusIcon, value: statusIcon }}
        />
        <Dropdown
          options={[
            { label: "sm", value: "sm" },
            { label: "md", value: "md" },
            { label: "lg", value: "lg" },
            { label: "xl", value: "xl" },
          ]}
          label="Avatar Status Icon"
          onChange={handleIconSizeChange}
          value={{ label: iconSize, value: iconSize }}
        />
        {Object.keys(show).map(
          (key, index) =>
            show[key as keyof ToastrState] && (
              <Toastr
                key={key}
                type={key as keyof ToastrState}
                iconColor={iconColor}
                actions={true}
                heading={heading}
                supportingText={text}
                imageSrc={image}
                iconSize={iconSize}
                onClose={() => handleToggle(key as keyof ToastrState)}
              ></Toastr>
            )
        )}
        <div className="d-flex gap1 mb-3">
          {Object.keys(show).map((key) => {
            const typedKey = key as keyof ToastrState;
            return (
              <Button
                key={typedKey}
                onClick={() => handleToggle(typedKey)}
                buttonType="button"
                label={`click ${typedKey}`}
                variant={show[typedKey] ? "primary" : "secondary"}
              ></Button>
            );
          })}
        </div>
        <div className="d-flex gap1 mb-3">
          <Button
            onClick={() => setShowActions(!showActions)}
            buttonType="button"
            label="No Actions Toastr"
            variant={showActions ? "primary" : "secondary"}
          ></Button>
          <Button
            onClick={() => setShowAvatar(!showAvatar)}
            buttonType="button"
            label="Avatar Toastr"
            variant={showAvatar ? "primary" : "secondary"}
          ></Button>
          <Button
            onClick={() => setShowCustom(!showcustom)}
            buttonType="button"
            label="custom icon"
            variant={showcustom ? "primary" : "secondary"}
          ></Button>
        </div>
        {showActions && (
          <Toastr
            key="actions"
            type="primary"
            iconColor={iconColor}
            actions={false}
            heading={heading}
            supportingText={text}
            onClose={() => setShowActions(false)}
          ></Toastr>
        )}
        {showAvatar && (
          <Toastr
            key="actions"
            type="avatar"
            statusIcon={statusIcon}
            avatarText="VS"
            iconSize={iconSize}
            actions={true}
            heading={heading}
            supportingText={text}
            onClose={() => setShowAvatar(false)}
          ></Toastr>
        )}
        {showcustom && (
          <Toastr
            key="actions"
            type="gray"
            actions={true}
            iconSize={iconSize}
            iconSrc={<CodepenLogo />}
            heading={heading}
            supportingText={text}
            onClose={() => setShowCustom(false)}
          ></Toastr>
        )}
      </Section>
    </>
  );
}
